export default {
  title: 'E-Leave',
  home: 'Home',
  tabs: {
    'employee-infomation': 'Employee Infomation',
    'leave-type': 'Leave Type',
    'leave-group': 'Leave Group',
    'leave-period': 'Leave Period',
    'report-setting': 'Report Setting',
    import: 'Import',
    export: 'Export'
  },
  'employee-information': {
    title: 'Employee information',
    visibility: 'Visibility',
    form: {
      name: 'Name - Surename',
      position: 'Position',
      email: 'Email'
    }
  },
  'leave-period': {
    title: 'Year',
    form: {
      year: 'Generate Year',
      'year-placeholder': 'Please select year',
      close: 'Forced change status'
    },
    table: {
      'leave-type': 'Leave Type',
      'period-from': 'Period From',
      'period-to': 'Period To',
      'approve-all': 'Approve All',
      'reject-all': 'Reject All',
      approve: 'Approve',
      reject: 'Reject'
    },
    error: {
      'not-select-value': 'please select a value of Close Period',
      'not-select-approve-reject': 'please select apporval or reject'
    }
  },
  'report-setting': {
    form: {
      status: 'Status',
      leave: 'Format of leave reported',
      cal: 'Standard hours per day for calculating hours as leave',
      'by-day': 'Base day hour minute',
      'by-hundred': 'Base 100',
      round: 'Rounding of leave days',
      hours: 'Hours',
      noround: 'No rounding',
      floor: 'Round off',
      ceil: 'Round up to 1',
      policy: 'Round via policy',
      roundup: 'Round up if 0.5 or more',
      rounddown: 'Round down if less than 0.5',
      'speacial-one': 'Special conditions 1'
    }
  },

  'leave-group': {
    'form-sections': {
      general: 'Group information',
      types: 'Leave types',
      scope: 'Employee scope',
      exclusions: 'Excluded employees',
      limits: 'Per-request limits'
    },
    studio: {
      filters: 'Filters',
      list: 'Leave groups'
    },
    toast: {
      'delete-pending-transaction':
        'Cannot delete this leave group because a leave type in the group has requests awaiting approval or cancellation.',
      'delete-failed': 'Unable to delete the leave group. Please try again.'
    },
    'add-leave-group': 'Add New Leave Group',
    'edit-leave-group': 'Edit New Leave Group',
    'filter-form': {
      'search-placeholder': 'Search Leave Group',
      'status-placeholder': 'Status',
      'search-label': 'Leave Group',
      'status-label': 'Status'
    },
    'add-button': 'Add new',
    modal: {
      title: 'Would you like to delete this leave group?',
      accept: 'YES',
      cancel: 'NO'
    },
    table: {
      id: 'No.',
      code: 'Leave Group Code',
      minLeavePerTime: 'Minimum days of leave per time',
      maxLeavePerTime: 'Maximum days of leave per time',
      leaveGroupDescriptionTH: 'Leave Group Description TH',
      leaveGroupDescriptionEN: 'Leave Group Description EN',
      status: 'Status'
    },
    form: {
      code: 'Leave Group Code',
      status: 'Status',
      'description-th': 'Leave Group Description TH',
      'description-en': 'Leave Group Description EN',
      'leave-type-code': 'Leave Type Code',
      level: 'Leave Code',
      organizational: 'Organization Chart',
      'job-type': 'Job level',
      job: 'Postion',
      category: 'Type',
      'employee-except': 'Employee except',
      'employee-code': 'Employee code',
      'employee-name': 'Name-Surname',
      'min-leave': 'Minimum days of leave per time',
      'max-leave': 'Maximum days of leave per time'
    }
  },
  'company-table': require('./CompanyTable.js').default,
  'leave-type': {
    'form-sections': {
      general: 'Leave type information',
      entitlement: 'Entitlements and calculation',
      restrictions: 'Permissions and restricted periods',
      requests: 'Request conditions',
      payment: 'Payment and leave cycle',
      workflow: 'Display and workflow'
    },
    studio: {
      filters: 'Filters',
      list: 'Leave types',
      scope: 'Active leave types across the company group'
    },
    help: require('./LeaveTypeHelp').default,
    'add-button': 'Add new',
    'cal-leave': 'Calculate leave authorization',
    'calculation-information': {
      button: 'Calculation information',
      title: 'About leave entitlement calculation',
      close: 'Close',
      purpose: {
        title: 'What does this button do?',
        description:
          'Starts a check and calculation of employee leave entitlements using employee information and leave type settings, with the current date as the reference date.'
      },
      when: {
        title: 'When should I use it?',
        description:
          'Use it after saving a new or updated leave type when you want the system to process entitlements using the latest settings.'
      },
      scope: {
        title: 'Which records are included?',
        description:
          'The system considers active leave types in the company group you are signed in to. It is not limited to the company currently open or the records filtered in the table.',
        example:
          'Example: Even if the table is filtered to one leave type, this button still processes active leave types in the company group.'
      },
      result: {
        title: 'How will entitlements change?',
        description:
          'The system creates or adjusts entitlements for eligible employees. The entitlement amount and grant period depend on the settings for each leave type.'
      },
      after: {
        title: 'What happens after I click?',
        description:
          'Processing runs in the background and may still be in progress when a success message appears. Please wait, then check employee entitlement balances, and avoid clicking again while waiting.'
      }
    },
    'filter-form': {
      'code-placeholder': 'Search Leave Type',
      'status-placeholder': 'Status',
      'code-label': 'Leave Type',
      'status-label': 'Status'
    },
    table: {
      id: 'No.',
      'leave-type-code': 'Leave Type Code',
      'leave-type-description-th': 'Leave Type Description TH',
      'leave-type-description-en': 'Leave Type Description EN',
      status: 'Status'
    },
    add_title: 'Add New Leave Type',
    edit_title: 'Edit New Leave Type',
    'second-section-title': 'Leave Set up',
    'set-detail-block-leave': 'Set Block Leave details',
    'block-leave-detail-title': 'Set details',
    'fifth-section-title': 'Approval setting',
    modal: {
      title: 'Would you like to delete this leave type?',
      button: {
        cancel: 'Cancel'
      },
      accept: 'Accept'
    },
    toast: {
      'success-title': 'Success',
      'delete-success': 'Delete data success',
      'delete-failed-title': 'Delete failed',
      'invalid-leave-type-id': 'Invalid leave type id',
      'delete-pending-transaction':
        'Cannot delete this leave type because there are pending leave transactions.'
    },
    form: {
      company: 'Company',
      'company-placeholder': 'Company Name',
      status: 'Status',
      'status-placeholder': 'Status',
      code: 'Leave Type Code',
      'code-placeholder': 'Leave Type Code',
      nameTH: 'Leave Type Name (TH)',
      'nameTH-placeholder': 'Leave Type Name (TH)',
      nameEN: 'Leave Type Name (EN)',
      'nameEN-placeholder': 'Leave Type Name (EN)',
      leaveTypeColor: 'Leave Type Color',
      'leaveTypeColor-placeholder': 'Enter a color code',
      gender: 'Gender',
      'gender-placeholder': 'Gender',
      officerType: 'Employee Status',
      'officerType-placeholder': 'Employee Status',
      active: 'Active',
      inactive: 'Inactive',
      male: 'Male',
      female: 'Female',
      'all-gender': 'All',
      'all-employee': 'All',
      'current-employee': 'Active',
      'newbie-employee': 'New Hire',
      'intern-employee': 'Probation',
      'newbie-and-intern-employee': 'New Hire and Probation',
      maxLeaveOverLifeTime: 'Maximum of years of service (Times)',
      'maxLeaveOverLifeTime-placeholder': 'Maximum of years of service (Times)',
      maxLeavePerYear: 'Maximum per year (Times)',
      'maxLeavePerYear-placeholder': 'Maximum per year (Times)',
      minLeaveDayPerTime: 'Minimum days of leave per time',
      'minLeaveDayPerTime-placeholder': 'Specify number',
      maxLeaveDayPerTime: 'Maximum days of leave per time',
      'maxLeaveDayPerTime-placeholder': 'Specify number',
      blockLeaveType: 'Block Leave',
      select: 'Set',
      unselect: 'None',
      workTimeCalculationType: 'Beginning of experience',
      startday: 'Hire Date',
      passpromotion: 'Probation End Date',
      permissionLeave: 'Authorization of leave',
      'leave-cycle': 'Leave cycle',
      'start-word-date': 'as of Hire Date',
      'probation-expiration-date': 'as of Probation End Date',
      'every-start-month': 'Increase (Every first day of the month)',
      'every-end-month': 'Increase (Every last day of the month)',
      'service-life': 'Year of Service',
      'first-leave-date': 'Date of first leave',
      identify: 'Specify number',
      days: 'Days',
      permissionCalculation: 'Calculation of leave permission',
      'full-integer': 'Full',
      'calculate-proportions': 'Proportion',
      roundDay: 'Prorate calculation',
      'round-start-work': 'Calculation from hire date',
      'round-pass-probation': 'Calculation from probation date',
      roundType: 'Rounding leave permission',
      round: 'Rounding',
      noround: 'No rounding',
      floor: 'Round off',
      ceil: 'Round up to 1',
      policy: 'Round via policy',
      roundup: 'Round up if 0.5 or more',
      rounddown: 'Round down if less than 0.5',
      'speacial-one': 'Special conditions 1',
      leaveDayCalculationType: 'Counting time',
      'only-max-lifetime': 'Identify maximum of year of service only',
      'only-max-peryear': 'Identify maximum per year only',
      'only-both': 'Identify all of both',
      'not-select': 'Not identify all of both',
      'not-include-dayoff': 'Exclude day off',
      weekend: 'Include weekends only',
      'weekend-dayoff': 'Include weekends and public holidays',
      order: 'No.',
      'min-leave-label': 'Minimum days of leave',
      'min-leave-placeholder': 'Minimum days of leave',
      'start-date-label': 'From Date',
      'end-date-label': 'To Date',
      'round-month-label': 'Month rounding',
      'round-to-day': 'rounded to days',
      date: 'Date',
      month: 'Month',
      'organize-placeholder': 'Organization Chart',
      'organize-label': 'Organization Chart',
      'position-placeholder': 'Position',
      'position-label': 'Position',
      'level-placeholder': 'Job Level',
      'level-label': 'Job Level',
      'period-of-employment': 'Period of employment for leave permission',
      'number-placeholder': 'number',
      to: 'to',
      from: 'form',
      entitlement: 'Leave days permission',
      'forward-type-label': 'Carry',
      'expire-type-label': 'Determine the date for allowed to use leave.',
      isAllowOverdue: 'Approve for excess leave',
      allow: 'Approve ',
      notallow: 'Reject',
      isActiveForbiddenDate: 'Set no leave period',
      startDate: 'Start date',
      endDate: 'End date',
      prospectLeave: 'Schedule advance leave',
      retrospectLeave: 'Schedule leave date back',
      isRequireAttachment: 'Force attached document',
      isRequireReason: 'Force leave reason',
      force: 'Set',
      notforce: 'None',
      reasonTextHeader: 'notify message of leave reason',
      isAllowOverLeave: 'Over leave',
      isAllowUrgentLeave: 'Urgent leave approval',
      inMonthCondition: 'Leave date must be in month',
      'no-need-in-month': 'Not in month',
      birthday: 'Birth date',
      partnerbirthday: 'Spouse birth date',
      chlidbirthday: 'Child birth date',
      'payment-label': 'Payout',
      unpay: 'Unpaid',
      pay: 'Paid',
      'leave-period-label': 'Leave cycle',
      dependcalendar: 'According to Calendar',
      identifydate: 'Specify date',
      shelveDayConfig: 'Disqualified by year',
      undefined1: 'Not Identify',
      'start-from-leave-year': 'Year of start leave',
      'seperate-year': 'Disqualified by separate year',
      'display-priority-label': 'Display No.',
      'display-priority-placeholder': 'Identify display order',
      'workflow-approve': 'Workflow Approve',
      'workflow-approve-placeholder': 'Select Workflow Approve',
      'workflow-cancel': 'Workflow disapprovae',
      'workflow-cancel-placeholder': 'Select workflow disapprove'
    }
  }
}
